import React from 'react';
import Header from '../components/Header';
import Reglements from './Reglements';
import Footer from '../components/Footer';
import useSEO from '../components/SEO';
import SearchStudent from './SearchStudent';

const StudentLifePage: React.FC = () => {
    useSEO({
        title: "Vie Étudiante - ISTMECH",
        description: "Vie étudiante et règlements de l'Institut Supérieur de Technologie Médicale du Cap-Haïtien.",
        keywords: "ISTMECH, vie étudiante, règlements, étudiants",
        url: "https://www.istmech.edu.ht/vie-etudiante",
        image: "https://www.istmech.edu.ht/og-image.png"
    });

    return (
        <div className="App">
            <Header />
            <main className="pt-20">
                <Reglements />
                <SearchStudent />
            </main>
            <Footer />
        </div>
    );
};

export default StudentLifePage;
